import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "contact-edit" }
const _hoisted_2 = { class: "contact-edit__main" }
const _hoisted_3 = { class: "contact-edit__content" }
const _hoisted_4 = { class: "contact-edit__title" }
const _hoisted_5 = { class: "contact-edit__field-group" }
const _hoisted_6 = { class: "contact-edit__field-group" }
const _hoisted_7 = { class: "contact-edit__field-group" }
const _hoisted_8 = { class: "contact-edit__field-group" }
const _hoisted_9 = {
  class: "contact-edit__label",
  for: "contactPhoneInput"
}
const _hoisted_10 = { class: "contact-edit__content" }
const _hoisted_11 = ["disabled"]

import { fetchPageBuilder } from '@drapejs/core';
import { isValidPhoneNumber } from 'libphonenumber-js';
import MyPagesBack from './MyPagesBack.vue';
import ErrorMessage from '../../forms/ErrorMessage.vue';
import PhoneInput from '../../forms/PhoneInput.vue';

import { validateEmail } from '../../../helpers/utils';

import * as bellaliteUser from '@/connectors/user';
import { computed, onMounted, ref } from 'vue';
import useContext from '@/composables/useContext';
import useWebsiteTexts from '@/composables/useWebsiteTexts';
import { FILEDS_CHARACTERS_LIMIT } from '@/constants';
import TextInput from '@/components/forms/TextInput.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ContactEdit',
  props: {
  contactData: {
    type: Object,
    required: false,
  },
},
  emits: ['saved', 'close-modal', 'back'],
  setup(__props, { emit }) {

const props = __props;





const { websiteText } = useWebsiteTexts();
const { route, cart, invoke } = useContext();

const no = ref('');
const code = ref('');
const systemId = ref('');
const firstName = ref('');
const firstNameError = ref('');
const lastName = ref('');
const lastNameError = ref('');
const email = ref('');
const emailError = ref('');
const phone = ref('');
const phoneError = ref('');
const saveError = ref('');
const requestPending = ref(false);

const phoneCountry = computed(() => {
  return cart.countryId;
});

const isFirstNameLengthExceeded = computed(
  () => (firstName.value?.length || 0) > FILEDS_CHARACTERS_LIMIT.firstName
);

const isLastNameLengthExceeded = computed(
  () => (lastName.value?.length || 0) > FILEDS_CHARACTERS_LIMIT.lastName
);

const firstNameErrorMessage = computed(
  () =>
    firstNameError.value ||
    (isFirstNameLengthExceeded.value
      ? websiteText('global__text_limit_exceeded').value
      : '')
);

const lastNameErrorMessage = computed(
  () =>
    lastNameError.value ||
    (isLastNameLengthExceeded.value
      ? websiteText('global__text_limit_exceeded').value
      : '')
);

function validate() {
  let isValid = true;

  if (!firstName.value) {
    firstNameError.value = websiteText('global__required_field').value;
    isValid = false;
  }

  if (!lastName.value) {
    lastNameError.value = websiteText('global__required_field').value;
    isValid = false;
  }

  if (isFirstNameLengthExceeded.value || isLastNameLengthExceeded.value)
    isValid = false;

  if (!email.value) {
    emailError.value = websiteText('global__required_field').value;
    isValid = false;
  }

  if (!validateEmail(email.value)) {
    emailError.value = websiteText('global__email_invalid').value;
    isValid = false;
  }

  if (!phone.value) {
    phoneError.value = websiteText('global__required_field').value;
    isValid = false;
  }

  if (!isValid) {
    return false;
  }

  try {
    if (!isValidPhoneNumber(phone.value, phoneCountry.value)) {
      phoneError.value = websiteText('global__invalid_phone').value;
      return false;
    }
  } catch (err) {
    phoneError.value = websiteText('global__invalid_phone').value;
    return false;
  }

  return true;
}

async function save() {
  saveError.value = '';

  if (!validate()) {
    return;
  }

  await addOrUpdateContact();
}

async function addOrUpdateContact() {
  const requestArgs = buildCommandArgs({
    no: no.value,
    code: code.value,
    systemId: systemId.value,
    firstName: firstName.value,
    lastName: lastName.value,
    email: email.value,
    phone: phone.value,
    saveOnOrganization: true,
  });

  const response = await executeCommand(
    bellaliteUser.commands.addOrUpdateContact,
    requestArgs
  );

  switch (response.error) {
    case 'FAILED':
      saveError.value = websiteText('global__save_error').value;
      break;

    default:
      emit('saved');
      break;
  }
}

function closeModal() {
  emit('close-modal');
}
function onBack() {
  emit('back');
}

function updatePhoneNumber(phoneNumber: any) {
  phone.value = phoneNumber;
  phoneError.value = '';
}
function buildCommandArgs(formArgs: any) {
  return {
    ...formArgs,
    ...fetchPageBuilder(
      route.protocol,
      route.host,
      route.pathname,
      { ...route.query },
      ''
    ),
  };
}
async function executeCommand(command: any, args: any) {
  try {
    requestPending.value = true;
    const response = await invoke(command, args);
    return response;
  } catch (err) {
    return [];
  } finally {
    requestPending.value = false;
  }
}

onMounted(() => {
  no.value = props.contactData?.no;
  code.value = props.contactData?.code;
  systemId.value = props.contactData?.systemId;
  firstName.value = props.contactData?.firstName;
  lastName.value = props.contactData?.lastName;
  email.value = props.contactData?.email;
  phone.value = props.contactData?.phone;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(MyPagesBack, {
        onBack: _cache[0] || (_cache[0] = ($event: any) => (onBack())),
        onExit: _cache[1] || (_cache[1] = ($event: any) => (closeModal()))
      }),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(websiteText)('mypages__contact').value), 1),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(TextInput, {
            type: "text",
            id: "firstName",
            autocomplete: "given-name",
            label: _unref(websiteText)('global__first_name').value,
            modelValue: firstName.value,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((firstName).value = $event)),
            onInput: _cache[3] || (_cache[3] = ($event: any) => (firstNameError.value = '')),
            "error-message": firstNameError.value,
            showCharactersCount: true,
            hasCountError: _unref(isFirstNameLengthExceeded),
            charactersCountText: 
              _unref(websiteText)('global__characters_count', {
                maxcharacters: _unref(FILEDS_CHARACTERS_LIMIT).firstName,
                count: firstName.value?.length || 0,
              }).value
            
          }, null, 8, ["label", "modelValue", "error-message", "hasCountError", "charactersCountText"])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(TextInput, {
            type: "text",
            id: "lastName",
            autocomplete: "family-name",
            label: _unref(websiteText)('global__last_name').value,
            modelValue: lastName.value,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((lastName).value = $event)),
            onInput: _cache[5] || (_cache[5] = ($event: any) => (lastNameError.value = '')),
            "error-message": lastNameError.value,
            showCharactersCount: true,
            hasCountError: _unref(isLastNameLengthExceeded),
            charactersCountText: 
              _unref(websiteText)('global__characters_count', {
                maxcharacters: _unref(FILEDS_CHARACTERS_LIMIT).lastName,
                count: lastName.value?.length || 0,
              }).value
            
          }, null, 8, ["label", "modelValue", "error-message", "hasCountError", "charactersCountText"])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(TextInput, {
            type: "text",
            id: "email",
            autocomplete: "email",
            label: _unref(websiteText)('global__email').value,
            modelValue: email.value,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((email).value = $event)),
            onInput: _cache[7] || (_cache[7] = ($event: any) => (emailError.value = '')),
            "error-message": emailError.value
          }, null, 8, ["label", "modelValue", "error-message"])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("label", _hoisted_9, _toDisplayString(_unref(websiteText)('global__phone').value), 1),
          _createVNode(PhoneInput, {
            id: "contactPhoneInput",
            class: "contact-edit__phone-input",
            value: phone.value,
            "selected-country": _unref(cart).countryId,
            placeholder: _unref(websiteText)('global__phone').value,
            "error-message": phoneError.value,
            onInput: updatePhoneNumber
          }, null, 8, ["value", "selected-country", "placeholder", "error-message"])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("button", {
        class: "secondary-button contact-edit__button-wide",
        onClick: save,
        disabled: requestPending.value
      }, _toDisplayString(_unref(websiteText)('global__save').value), 9, _hoisted_11),
      (saveError.value)
        ? (_openBlock(), _createBlock(ErrorMessage, {
            key: 0,
            message: saveError.value
          }, null, 8, ["message"]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})